export default remote => ({
    load: (key, data) => remote.get(`user/data-session/${key}`, {params: data}),
    flightSearch: () => remote.get(`user/data-session/flight-search`)
});
